import { useEffect, useState } from "react";
import axios from "axios";

const useFetchAllData = () => {
  const [allData, setAllData] = useState({
    sites: [],
    plugins: [],
    themes: []
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAllData = async () => {
    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        setIsLoading(false);
        return;
      }

      const apiUrl = process.env.REACT_APP_DOMAIN_URL + "/api/all-data";
      console.log("[FRONTEND] Chargement de toutes les données depuis:", apiUrl);

      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        },
      });

      const { sites, plugins, themes } = response.data;
      console.log("[FRONTEND] Données reçues:", {
        sites: sites.length,
        plugins: plugins.length,
        themes: themes.length
      });

      setAllData({ sites, plugins, themes });
      setIsLoading(false);
    } catch (error) {
      console.error("[FRONTEND] Erreur lors du chargement:", error);
      setError(error);
      setIsLoading(false);
    }
  };

  const refreshData = () => {
    setIsLoading(true);
    fetchAllData();
  };

  const updatePluginPayant = (slug, payant) => {
    setAllData((prev) => ({
      ...prev,
      plugins: prev.plugins.map((group) => ({
        ...group,
        plugins: group.plugins.map((p) =>
          (p.slug || p.name) === slug ? { ...p, payant } : p
        ),
      })),
    }));
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  return {
    fileContent: allData.sites,
    pluginData: allData.plugins,
    themeData: allData.themes,
    isLoading,
    error,
    refreshData,
    updatePluginPayant
  };
};

export default useFetchAllData;
